import { render, staticRenderFns } from "./StoreOnlineThemeChange.vue?vue&type=template&id=2ff8408b&scoped=true&"
import script from "./StoreOnlineThemeChange.vue?vue&type=script&lang=js&"
export * from "./StoreOnlineThemeChange.vue?vue&type=script&lang=js&"
import style0 from "./StoreOnlineThemeChange.vue?vue&type=style&index=0&id=2ff8408b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff8408b",
  null
  
)

export default component.exports